export default "__VITE_ASSET__B1ZlZ7$4__"